export default "__VITE_PUBLIC_ASSET__78e50951__"